import { observer } from "mobx-react-lite";
import { Box, Flex } from "@chakra-ui/react";

import { useIsReady } from "@noli/business";

import { themeStore } from "@/stores/theme";
import { useCopyPaste } from "@/hooks/usePasteImage";

function BoardPanel() {
  const isReady = useIsReady();
  useCopyPaste();
  const { boardBg } = themeStore.styles;

  return (
    <Flex h="100%" flex={1} direction="column">
      <Box w="100%" h="100%" bg={boardBg}>
        <Box id="board.container" visibility={isReady ? "visible" : "hidden"}></Box>
      </Box>
    </Flex>
  );
}

export default observer(BoardPanel);
